import React from 'react'
import AboutSection from "./AboutSection";
import Ourservices from "./Ourservices"
import Brands from "./Brands"
import "../styles/about.css"

function About() {
    return (
        <>
         <AboutSection /> 
         <Ourservices />
         <Brands /> 
        </>
    )
}

export default About
